(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-default"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // <sticky-header> element
      this.headerWrapper = this;
      // Inner .header bar
      this.innerHeader = this.querySelector('.header');
      this.headerBounds = { bottom: 0 };

      // Bind scroll handler
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      // Capture the header's original position/height BEFORE it becomes fixed
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const target = this.innerHeader || this.headerWrapper;
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        // We only need this once; after that we stop observing
        obs.disconnect();
      });
      observer.observe(target);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      // When we scroll past the original header bottom, make it sticky
      if (scrollTop > this.headerBounds.bottom) {
        this.headerWrapper.classList.add('shopify-section-header-sticky');
      } else {
        this.headerWrapper.classList.remove('shopify-section-header-sticky');
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-home"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this; // wrapper with section-header
      this.innerHeader = this.querySelector('.header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const h = (this.innerHeader && this.innerHeader.offsetHeight) || 0;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const target = this.innerHeader || this.header;
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(target);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky'); // no 'animate'
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      const root = this.innerHeader || this;
      (root.querySelectorAll('header-menu') || []).forEach((d) => d.close && d.close());
    }

    closeSearchModal() {
      const root = this.innerHeader || this;
      const m = root.querySelector('details-modal');
      if (m && m.close) m.close(false);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
  } catch(e) { console.error(e); }
})();

})();
